import React, { useState, useEffect } from "react";
import { Spinner, MrSelect } from "mr_react_framework";
import { useDispatch, useSelector } from "react-redux";
import {
  appRegionSelector,
  currentUserSelector,
} from "views/Auth/Login/selector";
import { checkMob, displayPoints, getAPColorPallete } from "lib/utils/helperMethods";
import { Button, Col, Row, Space, Statistic, Table, Tag } from "antd";
import { actions as experienceActions } from "views/Experiences/redux";
import { activeAdjustedExperienceSelector, experienceAnalyticsQuestionsSelector } from "views/Experiences/selector";
import loadable from "@loadable/component";
import { useTranslate } from "lib/MrTranslate/MrTranslate";

const RCJChart = loadable(() =>
  import(/* webpackChunkName: "react-chart" */ "views/Segments/RCJChart/RCJChart")
);

const QuestionsChart = (props) => {
  const { chartData } = props
  const mrIntl = useTranslate()
  console.log("ExperienceAnalyticsSummary QuestionsChart chartData", chartData)
  const apColors = getAPColorPallete();
  
  let chart_settings = {
    type: "bar",
    // type: "pie",
    // title: "Student performance",
    xAxesLabel: "Score range (%)",
    yAxesLabel: "Number of students",
    labels: chartData.labels, 
    // datasets: chartData.student_counts,
    // labels: ["10", "20", "30", "40"], // Column headers - week number or month number
    // labels: ["Jan", "Feb", "Mar", "Apr"], // Column headers - week number or month number
    datasets: [ // one object for each data row/line graph - one object for single line, multiple for multiple lines
      {
        data: chartData.dataset[0],
        label: mrIntl("ExperienceAnalyticsQuestions.unattempted"),
        backgroundColor: apColors.lightgrey // array for pie/bar if all different needed
      },
      {
        data: chartData.dataset[1],
        label: mrIntl("ExperienceAnalyticsQuestions.ungraded"),
        backgroundColor: apColors.grey
      },
      {
        data: chartData.dataset[2],
        label: mrIntl("CommonText.0_25_label"),
        backgroundColor: apColors.red
      },
      {
        data: chartData.dataset[3],
        label: mrIntl("CommonText.25_50_label"),
        backgroundColor: apColors.lightorange
      },
      {
        data: chartData.dataset[4],
        label: mrIntl("CommonText.50_75_label"),
        backgroundColor: apColors.green
      },
      {
        data: chartData.dataset[5],
        label: mrIntl("CommonText.75_100_label"),
        backgroundColor: apColors.blue
      },
      // Can't do this on same scale/axes as the student count y axis
      // {
      //   type: "line",
      //   data: chartData.dataset[4],
      //   label: "Average",
      //   // backgroundColor: apColors.blue
      // }
    ],
    showGridLines: false,
    showLegend: true,
    customColors: true, // only supported in bar for now
    stacked: true,
    // stepSize: 2, // using precision: 0 instead // only supported in bar for now
    
  }

  return <RCJChart chart_settings={chart_settings} />
}

const ExperienceAnalyticsQuestions = (props) => {
  console.log("ExperienceAnalyticsQuestions props ==>", props);
  // const { } = props;
  const dispatch = useDispatch();
  const currentUser = useSelector(currentUserSelector());
  const activeExperience = useSelector(activeAdjustedExperienceSelector());
  const experienceAnalyticsQuestionsData = useSelector(experienceAnalyticsQuestionsSelector());
  const mrIntl = useTranslate()
  useEffect(() => {
    dispatch(experienceActions.getAnalytics({experience_id: activeExperience.id, type: "questions"}))
    return () => {
    };
  }, []);

  console.log("ExperienceAnalyticsQuestions experienceAnalyticsQuestionsData", experienceAnalyticsQuestionsData);

  const columns = [
    // {
    //   title: mrIntl("CommonText.id"),
    //   dataIndex: "segment_id",
    //   key: "segment_id",
    //   sorter: (a, b) => a.segment_id.localeCompare(b.segment_id),
    //   sortDirections: ["ascend", "descend"],
    //   defaultSorter: "ascend",
    // },
    {
      title: mrIntl("CommonText.question"),
      dataIndex: "question_no",
      key: "question_no",
      sorter: (a, b) => a.question_no.localeCompare(b.question_no),
      sortDirections: ["ascend", "descend"],
      defaultSorter: "ascend",
    },
    {
      title: mrIntl("CommonText.type"),
      dataIndex: "question_type",
      key: "question_type",
      sorter: (a, b) => a.question_type.localeCompare(b.question_type),
      sortDirections: ["ascend", "descend"],
      // defaultSorter: "ascend",
    },
    {
      title: mrIntl("ExperienceAnalyticsQuestions.standards"),
      dataIndex: "syll_topic_labels",
      key: "syll_topic_labels",
      // width: 150,
      // sorter: (a, b) => a.question_type.localeCompare(b.question_type),
      // sortDirections: ["ascend", "descend"],
      // defaultSorter: "ascend",
      render: (_, item, rowIndex) => (
        item.syll_topic_labels.map((label) => { return <Tag>{label.substring(0,8)}</Tag>})
      ),
    },
    {
      title: mrIntl("ExperienceAnalyticsQuestions.max_points"),
      dataIndex: "points",
      key: "points",
      sorter: (a, b) => a.points - b.points,
      sortDirections: ["ascend", "descend"],
      // defaultSorter: "ascend",
      render: (_, item, rowIndex) => (
        displayPoints(item.points)
      ),
    },
    {
      title: mrIntl("ExperienceAnalyticsQuestions.avg_points"),
      dataIndex: "average_points",
      key: "average_points",
      sorter: (a, b) => a.average_points - b.average_points,
      sortDirections: ["ascend", "descend"],
      // defaultSorter: "ascend",
      render: (_, item, rowIndex) => (
        displayPoints(item.average_points)
      ),
    },
    {
      title: mrIntl("ExperienceAnalyticsQuestions.avg_percentage"),
      dataIndex: "average_percentage",
      key: "average_percentage",
      sorter: (a, b) => a.average_percentage - b.average_percentage,
      sortDirections: ["ascend", "descend"],
      // defaultSorter: "ascend",
      render: (_, item, rowIndex) => (
        displayPoints(item.average_percentage)
      ),
    },
    {
      title: mrIntl("ExperienceAnalyticsQuestions.attempted"),
      dataIndex: "attempted_percentage",
      key: "attempted_percentage",
      sorter: (a, b) => a.attempted_percentage - b.attempted_percentage,
      sortDirections: ["ascend", "descend"],
      // defaultSorter: "ascend",
    },
    {
      title: mrIntl("ExperienceAnalyticsQuestions.marked"),
      dataIndex: "marked_percentage",
      key: "marked_percentage",
      sorter: (a, b) => a.marked_percentage - b.marked_percentage,
      sortDirections: ["ascend", "descend"],
      // defaultSorter: "ascend",
    },
  ]

  return (
    <React.Fragment>
      {experienceAnalyticsQuestionsData.chart_data && <Row className="m-t-30">
        <Col span={24}>
           <QuestionsChart chartData={experienceAnalyticsQuestionsData.chart_data} />
        </Col>
      </Row>}
      {experienceAnalyticsQuestionsData.question_data && <Row className="m-t-30">
        <Col span={24}>
          {/* {JSON.stringify(experienceAnalyticsQuestionsData.question_data)} */}
          <Table
            // rowSelection={rowSelection}
            dataSource={experienceAnalyticsQuestionsData.question_data}
            columns={columns}
            pagination={false}
            // style={{ maxHeight: "500px", overflow: "auto" }}
          />
        </Col>
      </Row>}
    </React.Fragment>
  );
};

export default ExperienceAnalyticsQuestions;
